import { createSelector } from 'reselect';

const getAppSectionsReducer = (state) => state.containers.appSections;

export const selectPathList = createSelector(
  getAppSectionsReducer,
  (reducer) => reducer.pathList,
);
